import { useMemo } from 'react';

import {
    sensorConfigurationIncludesType,
    useDevicesCurrentSensorConfiguration,
} from '@/api/device/useSensorConfigurations';
import { Device } from '@/api/devices';

type UseHydrophoneDevicesOptions = {
    enabled?: boolean;
};

export const useHydrophoneDevices = (
    devices: Device[],
    { enabled = true }: UseHydrophoneDevicesOptions = {}
): Device[] => {
    const { data: deviceCurrentSensorConfigurations } = useDevicesCurrentSensorConfiguration({
        spotterIds: devices.filter((device) => device.isSmartMooring).map((device) => device.spotterId),
        config: { enabled },
    });
    return useMemo(
        () =>
            devices.filter((device: Device) => {
                const sensorConfiguration = deviceCurrentSensorConfigurations?.[device.spotterId];
                if (!sensorConfiguration?.length) {
                    return false;
                }
                return sensorConfigurationIncludesType(sensorConfiguration, 'hydrophone');
            }),
        [devices, deviceCurrentSensorConfigurations]
    );
};
